import React, {Component} from 'react';  
 
import axios from "axios"; 
import { StageSpinner , HeartSpinner } from "react-spinners-kit"; 
 
import config from  '../../config';

class SignUpForm1 extends Component{
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            stagename: '',
            cell: '',
            vmethod: 'sms',
            xsmode: document.getElementById('xs-online-app').getAttribute('data-mode'),
            state: 1,
            messageBox: '',
            messageBoxState: 1 ,
            loading: false,
        }

    }

    getSignUpParams = () => {
        this.props.getSignUpParams( this.state );
    }

    nextStep = () => {
        this.props.nextStep();
    }

    handleChange(e) { 
            this.setState({[e.target.name]: e.target.value}); 
    }

    sendRequest = () =>{ 

          this.setState({messageBox: 'Loading....' })
          this.setState({loading: true})
 
          let data  = { 
                  action: 'signUpSubscription', 
                  formdata: {
                      stagename: this.state.stagename, 
                      email: this.state.email, 
                      cell: this.state.cell, 
                      vmethod: this.state.vmethod, 
                      xsmode: this.state.xsmode, 
                      action: 'singup-step1', 
                  }
          }; 
         
          axios.post( config.API_URL ,JSON.stringify(data) ,{  
                  dataType: 'json',
                  cache: false, 
                  headers: {   
                    "Content-Type": "application/json",  
                    "cache-control": "no-cache"
                  }  
                }                
              )
              .then(res => { 

                if( res.data.state < 0 ){
                    this.setState({messageBox: res.data.message })
                    this.setState({messageBoxState: res.data.state })
                    this.setState({loading: false })
                } else {
                  console.log( res );
                  this.setState({messageBox: res.data.message })
                  this.setState({messageBoxState: res.data.state })
                  this.setState({loading: false })
                  this.getSignUpParams();
                }
              })
              .catch(error => {
                this.setState({messageBox: 'Wrong data' })
                this.setState({loading: false })
              }); 
      } 
 
    render(){
         
        return (
            <div className="container-fluid"> 

                <div className="signupInfoBox "  >
                    <div id="div_id_stagename" className="form-group row"  > 
                        <label for="id_stagename" className="control-label col-lg-12 form-label requiredField text-start" >
                            Stagename<span className="asteriskField">*</span> </label> 
                        <div className="controls col-lg-12 form-field"> 
                            <input className="required input-sm textinput textInput form-control" 
                            id="id_stagename" maxlength="100" name="stagename" placeholder="e.g. Jessi" type="text"
                            value={this.state.stagename } onChange={(e) => {this.handleChange(e)} } /> 
                        </div> 
                    </div> 
                
                    <div id="div_id_email" className="form-group row"  > 
                        <label for="id_email" className="control-label col-lg-12 form-label requiredField text-start" >
                        E-mail<span className="asteriskField">*</span> </label> 
                        <div className="controls col-lg-12 form-field"> 
                            <input className="required input-sm textinput textInput form-control" 
                            id="id_email" name="email" placeholder="E-mail address" type="email"
                            value={this.state.email } onChange={(e) => {this.handleChange(e)} }/> 
                        </div> 
                    </div>
                
                    <div id="div_id_cell" className="form-group row"  > 
                        <label for="id_cell" className="control-label col-lg-12 form-label requiredField text-start"  >
                        Cell<span className="asteriskField">*</span> </label> 
                        <div className="controls col-lg-12 form-field"> 
                            <input className="input-sm textinput textInput form-control" 
                            id="id_cell" maxlength="20" name="cell" placeholder="+415551234" type="text"
                            value={this.state.cell } onChange={(e) => {this.handleChange(e)} } />
                        </div> 
                    </div> 

                    <div id="div_id_cell" className="form-group row"  > 
                      
                        <div className="col text-start" >
                            <input className="form-check-input" type="radio" name="vmethod"  checked={this.state.vmethod === "sms"}  value="sms" onChange={(e) => {this.handleChange(e)} }  />
                            <label className="form-check-label" for="inlineRadio2">Validation code by SMS</label>
                        </div>

                    </div> 

                    <div className="clear"></div>
                    
                        <div className={this.state.messageBoxState ? 'messageBox errorMsg' : ' messageBox successMsg'} >
                            <HeartSpinner
                                size={40}
                                color="#e4000d" 
                                loading={this.state.loading}
                            />  
                            <div className={this.state.messageBoxState ? 'errorMsg' : ' successMsg'}  > {this.state.messageBox}</div>
                        </div>

                        <div className="row buttonsBox">
                            <div className="col-md-1">&nbsp;</div>  
                            

                            <div className="col-md-10">
                                <input type="submit" name="sign-up" value="Send me validation code"  
                                className="btn btn-primary btn-primary btn-block register-now-btn g-recaptcha" 
                                id="submit-id-sign-up" onClick={this.sendRequest}   />
                           </div>  
                            

                            <div className="col-md-1">&nbsp;</div>
                        </div>

                        <div className="clear"></div>

                            <div  >
                                <p>Please check your email for a confirmation link…
                                We hate spam as much as you do, so we need to confirm your email address.
                                </p>    
                                <p>
                                To complete the subscription process, please click the link in the email we just sent you.  
                                If it doesn’t show up in a few minutes, check your spam folder.
                                </p>
                            </div>
                        </div>

    </div>
         )
    }


}



export default SignUpForm1;